module.exports = __webpack_public_path__ + "img/1f993.94450ef.svg";